import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { AdLayoutDialog } from '../../components/AdLayoutDialog';
import { AppButton } from '../../common/components/AppButton';
import { AppHelper } from '../../helpers/AppHelper';
import { CommonStyles } from '../../styles/Styles';
import { DeleteModal } from '../../common/components/DeleteModal';
import { AppUiHelper } from '../../helpers/AppUiHelper';

export class DisplayAds extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'DisplayAds'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.userType = this.options.pageForOrgType || ''
    this.pageTitle = Helper.getString('display-ads')
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.noAdd = true
    this.groupId = 'displayads' + this.orgId
    this.toFetch = [
      { method: 'GET', paths: ['items'], queryParams: { groupId: this.groupId, pb: 'fieldDef' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Image: (current) => {
        const image = current.image
        if(image && image.endsWith('.mp4')) return AppUiHelper.renderVideoThumbnailCustomStyle({content:image}, {}, {_IMAGEFIT: false})
        return AppUiHelper.itemImage({...current, image, _IMAGEFIT: false })
      },
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.title}</span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.adImage && current.adImage.endsWith('.mp4') ? 'VIDEO' : 'IMAGE'} | {current.durationSecs} Secs
            </span>
          </div>
        )
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId
    }
    this.addNewLabel = 'Create Ad'
    this.emptyText = ' ' // Since above header shows the buttons
    this.noTableHead = true
    this.actionData = {}
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    // const templateField = this.formDefinition.steps[0].fields.find(i => i.key === 'template')
    // templateField.options.push(
    //   { key: 'TEMPLATE5', label: 'Layout 5 (Circle Left)' },
    //   { key: 'TEMPLATE6', label: 'Layout 6 (Circle Right)' },
    //   { key: 'TEMPLATE7', label: 'Layout 7 (Square Left)' },
    //   { key: 'TEMPLATE8', label: 'Layout 8 (Square Right)' })
    const item = results[0]
    const items = item ? Helper.dictToArray(item.items) : []
    items.forEach(i => i.image = i.adImage || i.heroImage)
    this.setState({
      items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.actionData = { action: 'add' }
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = false
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onEdit(current) {
    this.actionData = { action: 'edit', currentId: current.id }
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  renderAboveTable() {
    return (
      <div className={css(CommonStyles.aboveTableContainer)}>
        <div className={css(CommonStyles.buttonImageContainer, CommonStyles.imageMarginRight)}
          onClick={() => {
            this.selectedITypeForCreate = 'CREATE'
            this.openModalForAdd()
          }}>
          <img src={require('../../assets/images/create_ad.png')}
            className={css(CommonStyles.buttonImage)} height='74' width='300' />
        </div>
        <div className={css(CommonStyles.buttonImageContainer)}
          onClick={() => {
            this.selectedITypeForCreate = 'UPLOAD'
            this.openModalForAdd()
          }}>
          <img src={require('../../assets/images/upload_ad.png')}
            className={css(CommonStyles.buttonImage)} height='74' width='300' />
        </div>
        {this.state.preview &&
          <DisplayPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            adLink={this.state.current.adImage}
            onClosed={() => this.setState({ preview: undefined })}
          />}
      </div>)
  }

  onActions(current) {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    actions.push(
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          {/* <i className='material-icons-outlined' onClick={() => { this.setState({ preview: true, current }) }}>visibility</i> */}
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true,  current  }) }} />
        </span>
      </Tooltip>
    )
    return actions
  }

  onDeleteAdComplete() {
    this.setState({
      modalOpen: false
    })
    this.fetchItems()
  }

  renderDeleteModal() {
    return (
      <DeleteModal open={this.state.modalOpen}
        onCancel={() => this.setState({ modalOpen: false })}
        onDeleteAdComplete={() => this.onDeleteAdComplete()}
        apiMethod={this.state.apiMethod}
        apiEndPoint={this.state.apiEndPoint}
      />
    );
  }

  renderModal() {
    if (this.formDefinition.formType === 'delete') {
      return this.renderDeleteModal()
      // return super.renderModal()
    }
    if (!this.state.modalOpen) return ''
    return (
      <AdLayoutDialog
        title={this.formDefinition.formType === 'add' ? 'Create Ad' : 'Edit'}
        isOpen={this.state.modalOpen ? true : false}
        onClosed={() => this.setState({ modalOpen: false })}
        orgId={this.orgId}
        apiMethod={this.state.apiMethod}
        apiEndPoint={this.state.apiEndPoint}
        uploadLocation={this.uploadLocation}
        selectedITypeForCreate={this.selectedITypeForCreate}
        apiData={this.state.apiData || this.apiData}
        onCompleteAction={
          () => {
            this.setState({ modalOpen: false }),
            this.selectedITypeForCreate = null
            this.fetchItems()
          }}
        adImage={'https://d3txy5owctt379.cloudfront.net/1654769118718/imgads/cb45d01022f711ed9bb3ed204b2a64cb.jpg'}
        formDefinition={this.formDefinition}
        customSubmit={(options)=> this.customSubmit(options)}
      />
    )
  }

  customSubmit(options) {
    const { formData, caller } = options
    const maxVideoDuration = 90
    if ((!formData.displayAdType || formData.displayAdType !== 'IMAGE') && formData.adImageName && Math.round(parseFloat(formData.durationSecs)) > maxVideoDuration && (this.userType === 'PARTNER' || this.userType === 'SITE')) {
      let errorMessage = Helper.getString('maxDurationVideo')
      errorMessage = errorMessage.replace('%second%',maxVideoDuration)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        message: errorMessage,
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.displayAdType === 'IMAGE' && (Math.round(parseFloat(formData.durationSecs)) > 15 || Math.round(parseFloat(formData.durationSecs)) < 5) && (this.userType === 'PARTNER' || this.userType === 'SITE')) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('maxDurationImage'),
        message: Helper.getString('maxDurationImage'),
        success: false,
        inProcess: false
      })
      return
    }
    let apiEnd = {}
    if (this.actionData && this.actionData.action === 'edit') {
      apiEnd = {
        method: 'PUT',
        paths: ['items', this.actionData.currentId],
        queryParams: { groupId: formData.groupId },
        jsonBody: { ...formData }
      }
    }
    if (this.actionData && this.actionData.action === 'add') {
      apiEnd = {
        method: 'POST',
        paths: ['items'],
        queryParams: { groupId: formData.groupId },
        jsonBody: { ...formData }
      }
    }
    ApiHelper.call(apiEnd, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false,
        })
        return
      } else {
        this.setState({ modalOpen: false })
        this.selectedITypeForCreate = null
        this.fetchItems()
      }
    })
  }

}

const Styles = StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/DisplayAds.js